import { Menu, X, BookOpen } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

export const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "Trailer Guides", href: "/trailer-guides" },
  { label: "Towing & CDL Education", href: "/towing-cdl" },
  { label: "Maintenance & Ownership", href: "/maintenance-ownership" },
  { label: "Industry Blog", href: "/blog" },
  { label: "About Juan", href: "/about" },
];

const SiteHeader = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => setMobileOpen(false), [location.pathname, location.hash]);

  const isActive = (href: string) =>
    href === "/" ? location.pathname === "/" : location.pathname.startsWith(href);

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-foreground/95 text-primary-foreground backdrop-blur supports-[backdrop-filter]:bg-foreground/85">
      <div className="container flex h-20 items-center justify-between gap-6">
        <Link to="/" className="font-display text-xl font-black uppercase tracking-wide text-white no-underline lg:text-2xl">
          Juan<span className="text-primary">TheTrailerGuy</span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="Main">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              aria-current={isActive(link.href) ? "page" : undefined}
              className={`rounded-md px-3 py-2 text-sm font-semibold transition-colors hover:text-primary ${
                isActive(link.href) ? "text-primary" : "text-white/85"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="text-white lg:hidden"
          aria-label="Toggle menu"
          aria-expanded={mobileOpen}
        >
          {mobileOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {mobileOpen && (
        <div className="border-t border-white/10 bg-foreground px-4 pb-4 lg:hidden animate-fade-in">
          <nav className="flex flex-col gap-1 pt-3" aria-label="Main mobile">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="rounded-md px-2 py-3 text-left text-base font-semibold text-white/90 hover:text-primary"
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/trailer-guides"
              className="mt-3 inline-flex items-center justify-center gap-2 rounded-lg bg-primary px-3 py-3 text-sm font-extrabold uppercase tracking-wide text-primary-foreground"
            >
              <BookOpen className="h-4 w-4" /> Explore Trailer Guides
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default SiteHeader;
